module.exports = __webpack_public_path__ + "img/scheme-default.4738a07a.jpg";